<template>
  <div id="ebgraphView"></div>
</template>
<script>
import { findFlowChartById } from '@/services/flowchart-service';
export default {
  name: 'flowChartView',
  data() {
    return {
      user: this.$store.state.user.userInfo,
      flowId: this.$route.params.flowId,
      timer: null,
      ebMxGraph: {}
    };
  },
  created() {},
  mounted() {
    let mxClient = document.createElement('script');
    mxClient.src = '/static/mxgraph/js/mxClient.js';
    document.body.appendChild(mxClient);
    this.timer = setInterval(() => {
      if (window.mxDefaultToolbarCodec) {
        clearInterval(this.timer);
        this.timer = null;
        this.init();
      }
    }, 1000);
  },
  methods: {
    async init() {
      this.findFlowChartByIdService();
    },
    async findFlowChartByIdService() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await findFlowChartById(this.flowId);
        if (data.returnCode === '01') {
          if (data.flowChart.flowXml) {
            let flowXml = data.flowChart.flowXml;
            this.ebMxGraph.flowXml = flowXml;
            let ebFlowChartXml = sessionStorage.getItem('ebFlowChartXml');
            if (ebFlowChartXml) {
              this.ebMxGraph.flowXml = ebFlowChartXml;
            }
            this.initGraph();
          } else {
            this.$message.error('您还没有编辑流程图');
          }
        } else if (data.returnCode === '03') {
          this.$message.error(data.message);
        } else {
          this.$message.error('获取流程图失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.$root.layout.isLoading = false;
    },
    initGraph: function() {
      let container = document.getElementById('ebgraphView');
      if (!mxClient.isBrowserSupported()) {
        mxUtils.error('Browser is not supported!', 200, false);
      } else {
        container.style.position = 'absolute';
        container.style.overflow = 'auto';
        container.style.left = '0px';
        container.style.top = '55px';
        container.style.right = '0px';
        container.style.bottom = '0px';
        document.body.appendChild(container);
        if (mxClient.IS_QUIRKS) {
          document.body.style.overflow = 'auto';
          new mxDivResizer(container);
          new mxDivResizer(outline);
        }
        let model = new mxGraphModel();
        let graph = new mxGraph(container, model);
        this.ebMxGraph.graph = graph;
        this.ebMxGraph.model = model;
        this.settingGraph();
      }
    },
    settingGraph: function() {
      this.ebMxGraph.graph.setEnabled(false);
      this.ebMxGraph.graph.setCellsMovable(false);
      this.ebMxGraph.graph.setAutoSizeCells(true);
      this.ebMxGraph.graph.setPanning(true);
      this.ebMxGraph.graph.centerZoom = true;

      this.ebMxGraph.graph.setTooltips(!mxClient.IS_TOUCH);
      this.ebMxGraph.graph.htmlLabels = true;

      this.ebMxGraph.graph.getCursorForCell = function(cell) {
        if (cell != null && cell.value != null && cell.vertex == 1) {
          return 'pointer';
        }
      };

      this.ebMxGraph.graph.panningHandler.popupMenuHandler = false;
      this.initGraphData();
    },
    initGraphData: function() {
      this.ebMxGraph.graph.getModel().beginUpdate();
      try {
        var doc = mxUtils.parseXml(this.ebMxGraph.flowXml);
        var codec = new mxCodec(doc);
        codec.decode(doc.documentElement, this.ebMxGraph.graph.getModel());
      } finally {
        this.ebMxGraph.graph.getModel().endUpdate();
      }
      // 居中
      //this.ebMxGraph.graph.fit();
      this.ebMxGraph.graph.center(true, true, 0.5, 0.5);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>
<style lang="less">
</style>

